<form [formGroup]="productForm">

    <!-- <label>
        Title: <input formControlName="title" />
      </label> -->
      <h2>Selling Points</h2>
    
      <div formArrayName="selling_points">
        <div *ngFor="let item of sellingPoints.controls; let pointIndex=index" [formGroupName]="pointIndex">
            <label>Selling Point: <input formControlName="point" /></label>
            <label>Sec: <input formControlName="abc" /></label>
            <button type="button" (click)="deleteSellingPoint(pointIndex)">Delete Selling Point</button>
        </div>
        <button type="button" (click)="addSellingPoint()">Add Selling Point</button>
      </div>

  <p>{{ this.productForm.value | json }}</p>
